import React from "react";
import { useEffect, useMemo, useContext } from "react";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";


export const FormNuevoProducto = ({ objeto = null, categorias, postProducto, proveedores }) => {

  const [fechaDefault, setFechaDefault] = useState(null)

  const [categoriaValue, setCategoriaValue] = useState('')

  const [ proveedorValue, setProveedorValue ] = useState('')

  const inputRules = {
    categoria: {
      required: {
        value: true,
        message: "Campo requerido",
      },
    },
    proveedor: {
      required: {
        value: false
      }
    },
    nombre: {
      required: {
        value: true,
        message: "Campo requerido"
      },
      maxLength: {
        value: 200,
        message:"Maximo de 200 caracteres"
      }
    },
    codigo: {
      required: {
        value: true,
        message: "Campo requerido"
      },
      maxLength: {
        value: 50,
        message:"Maximo de 50 caracteres"
      }
    }
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: useMemo(() => {
      return objeto;
    }, [objeto]),
  });

  const onSubmit = (data) => {
    postProducto(data)
  };

  return (
    <form id="FormNuevoProducto" onSubmit={handleSubmit(onSubmit)}>
      <div className="p-fluid formgrid grid pt-2">

        <div className="field col-6">
            <label htmlFor="codigo">Codigo</label>
            <Controller
              name="codigo"
              control={control}
              defaultValue=""
              rules={inputRules.codigo}
              render={({ field }) => (
                <InputTextarea {...field} className={classNames({ 'p-invalid': errors?.codigo })} rows={1} cols={30} autoResize />
              )}
            />
            {errors?.codigo && <small className="p-error">{errors.codigo.message}</small>}
        </div>
        <div className="field col-12">
          <label htmlFor="categoria">Categoria</label>
          <Controller
            name="categoria"
            control={control}
            defaultValue=""
            rules={inputRules.categoria}
            render={({ field }) => (
              <Dropdown inputRef={field.ref} value={field.value}
                onChange={(e) => {
                  field.onChange(e);
                  setCategoriaValue(e);
                }}
                options={categorias}
                optionLabel="categoria" filter showClear filterBy="categoria"
                placeholder="Seleccione Categoria"
                className={classNames({ 'p-invalid': errors?.categoria })} />
            )}
          />
          {errors?.categoria && <small className="p-error">{errors.categoria.message}</small>}
        </div>

        <div className="field col-12">
          <label htmlFor="nombre">Nombre</label>
          <Controller
            name="nombre"
            control={control}
            defaultValue=""
            rules={inputRules.nombre}
            render={({ field }) => (
              <InputTextarea {...field} className={classNames({ 'p-invalid': errors?.nombre })} rows={1} cols={30}
              onChange={(e) => field.onChange(e.target.value.toUpperCase())}
              autoResize />
            )}
          />
          {errors?.nombre && <small className="p-error">{errors.nombre.message}</small>}
        </div>

        <div className="field col-12">
          <label htmlFor="proveedor">Proveedor</label>
          <Controller
            name="proveedor"
            control={control}
            defaultValue=""
            rules={inputRules.proveedor}
            render={({ field }) => (
              <Dropdown inputRef={field.ref} value={field.value}
                onChange={(e) => {
                  field.onChange(e);
                  setCategoriaValue(e);
                }}
                options={proveedores}
                optionLabel="nombre" filter showClear filterBy="nombre"
                placeholder="Seleccione Proveedor"
                className={classNames({ 'p-invalid': errors?.proveedor })} />
            )}
          />
          {errors?.proveedor && <small className="p-error">{errors.proveedor.message}</small>}
        </div>
      </div>
    </form>
  );
};

export default FormNuevoProducto;
